import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle, faMinusCircle } from '@fortawesome/free-solid-svg-icons'

import dateFormat from 'dateformat';

import { naValue } from '../constants';


class TimelineEntry extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
            entry: props.entry,
        }
        this.toggleExpand = this.toggleExpand.bind(this);
    }

    toggleExpand() {
        this.setState({ expanded: !this.state.expanded });
    }


    renderLearnMore = () => {

        let entry = this.props.entry;

        let learnMoreClass = "TimelineEntryLearnMoreDataGrid Roboto Bold"
        if (!this.state.expanded) {
            learnMoreClass += " hidden-unless-print";
        }

        return (
            <div className={learnMoreClass}>

                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Specific Cause:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.specificCause || naValue}
                    </div>
                </div>

                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Date Extinguished:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.outDate ? dateFormat(entry.outDate, "mmmm dS, yyyy") : naValue}
                    </div>
                </div>

                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Structures Threatened:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.otherStructuresThreatened || naValue}
                    </div>
                </div>


                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Structures Destroyed:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.otherStructuresDestroyed || naValue}
                    </div>
                </div>

                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Residences Threatened:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.residencesThreatened || naValue}
                    </div>
                </div>

                <div className="TimelineEntryLearnMoreDataGridRow">
                    <div className="TimelineEntryLearnMoreDataGridHeadersItem">
                        Residences Destroyed:
                    </div>
                    <div className="TimelineEntryLearnMoreDataGridValuesItem">
                        {entry.residencesDestroyed || naValue}
                    </div>
                </div>

            </div>
        );

    }

    render() {
        let entry = this.props.entry;



        let acreValue = entry.acres ? parseInt(entry.acres.toFixed(0)) : naValue;

        let acreDisplayValue = 'Less Than 1 Acre';
        if (acreValue === 1) {
            acreDisplayValue = '1 Acre';
        }
        else if (acreValue > 1) {
            acreDisplayValue = `${acreValue.toLocaleString()} Acres`;
        }

        let bodyClass = "TimelineEntryBody Bold";

        // The highlighted property is a tri-state property. It can be either true, false, or null.
        // When it is null we assume nothing is highlighted and thus do not apply any class.
        // When it is true we apply the highlighted class.
        // When it is false we apply the not-highlighted class. This causes the entry to be slightly transparent.

        if (this.props.highlighted === true)
            bodyClass += " highlighted";
        else if (this.props.highlighted === false)
            bodyClass += " not-highlighted";

        return (
            <div className="TimelineEntry" key={entry.id} id={`timeline_${entry.id}`}>
                <div className="TimelineEntryWrapper">
                    <div className="TimelineEntryContent">
                        <div className={bodyClass}>
                            <div className="TimelineEntryBodyDataGrid Bold">
                                <div className="TimelineEntryBodyDataGridColumn">
                                    <div className="TimelineEntryBodyDataGridColumnHeader Oswald">
                                        Date Discovered
                                    </div>
                                    <div className="TimelineEntryBodyDataGridColumnValue Roboto">
                                        {entry.discoveryDate ? dateFormat(entry.discoveryDate, "mmmm dS, yyyy") : naValue}
                                    </div>
                                </div>
                                <div className="TimelineEntryBodyDataGridColumn">
                                    <div className="TimelineEntryBodyDataGridColumnHeader Oswald">
                                        Wildfire Name
                                    </div>
                                    <div className="TimelineEntryBodyDataGridColumnValue Roboto">
                                        {entry.name || naValue}
                                    </div>
                                </div>
                                <div className="TimelineEntryBodyDataGridColumn Oswald">
                                    <div className="TimelineEntryBodyDataGridColumnHeader">
                                        Size
                                    </div>
                                    <div className="TimelineEntryBodyDataGridColumnValue Roboto">
                                        {acreDisplayValue}
                                    </div>
                                </div>
                                <div className="TimelineEntryBodyDataGridColumn">
                                    <div className="TimelineEntryBodyDataGridColumnHeader Oswald">
                                        Fire Cause
                                    </div>
                                    <div className="TimelineEntryBodyDataGridColumnValue Roboto">
                                        {entry.generalCause || naValue}
                                    </div>
                                </div>
                                <div className="TimelineEntryBodyDataGridColumn min-width-19-em no-print">
                                    <div className="TimelineEntryBodyDataGridColumnHeader Oswald">
                                        &nbsp;
                                    </div>
                                    <div className="TimelineEntryBodyDataGridColumnValue Roboto flex no-print">
                                        {this.props.highlighted ? ( // if highlighted show the deselect button
                                            <button className='viewOnMapButton right margin-right-1em button secondary' onClick={evt => { this.props.onEntryDeselected(evt) }}>
                                                <div>Deselect</div>
                                            </button>
                                        ) : (<div className='fill-x' />
                                        )}
                                        <button className='viewOnMapButton right button primary' onClick={evt => { this.props.onEntrySelected(entry, evt) }}>
                                            <div>View in Map</div>
                                        </button>

                                    </div>
                                </div>
                            </div>

                            <div className="TimelineEntryBodyLearnMore">
                                <div className="TimelineEntryBodyLearnMoreHeader no-print">
                                    <button className='expand-button' onClick={this.toggleExpand} >
                                        <FontAwesomeIcon icon={this.state.expanded ? faMinusCircle : faPlusCircle} className="expand-icon" color={"#FFF"} />
                                    </button>
                                    Learn More
                                </div>
                                {this.renderLearnMore()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TimelineEntry;